export const ZIndexes = {
  fullscreen: 11,
  modal: 10,
  modalResults: 5,
  envIdentifier: 5,
  submenuMobile: 8,
  feedback: 8,
  submenu: 6,
  evaluatorBar: 6,
  sidebar: 7,
  header: 3,
  overlay: 1,
  audioDownload: 98,
  loading: 99,
  installModal: 100,
  tokenExpired: 100,
  // The re-auth overlay is opaque and fixed, so any modal opened from inside it
  // (2FA) must sit above it — react-modal portals to <body>, not into the overlay.
  tokenExpiredModal: 101,
};
